export const ru = {
  "app.title": "survivrr.io",
  "menu.online": "Онлайн",
  "menu.offline": "Офлайн",
  "menu.play": "Играть",
  "menu.name": "Имя",
  "menu.ballColor": "Цвет шарика",
  "menu.nameColor": "Цвет имени",
  "menu.moreInfo": "Подробнее",
  "menu.moreInfoTitle": "Подробнее",
  "menu.moreInfoSubtitle": "Юридические страницы, сведения о cookies и контакты.",
  "menu.back": "Назад",
  "menu.privacySettings": "Настройки конфиденциальности",
  "menu.cookiePolicy": "Политика cookies",
  "menu.privacyPolicy": "Политика конфиденциальности",
  "menu.termsOfService": "Условия использования",
  "menu.emailButton": "Написать e-mail",
  "menu.websiteButton": "Посмотреть мой сайт",
  "menu.contactEmailLabel": "Контактный e-mail:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Посмотреть мой сайт:",
  "menu.nameRequired": "Сначала введите имя.",
  "moreInfo.privacySettings.intro1": "Вы можете управлять настройками конфиденциальности на этом сайте через сообщение о согласии, показываемое нашим рекламным провайдером, когда оно доступно.",
  "moreInfo.privacySettings.intro2": "Вы также можете в любое время управлять cookies и локальным хранилищем в настройках браузера.",
  "moreInfo.privacySettings.adsHeading": "Настройки рекламы",
  "moreInfo.privacySettings.adsParagraph": "Некоторые объявления могут предоставляться Google или другими партнерами. Параметры персонализированной рекламы также можно изменить напрямую в настройках рекламы Google.",
  "moreInfo.privacySettings.adsBullet1": "Откройте настройки рекламы Google на myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Очистите cookies или данные сайта, если хотите сбросить выбор согласия.",
  "moreInfo.privacySettings.adsBullet3": "Используйте настройки конфиденциальности браузера, чтобы блокировать или ограничивать cookies.",
  "moreInfo.privacySettings.localHeading": "Локальные настройки",
  "moreInfo.privacySettings.localParagraph": "Игра сохраняет базовые локальные настройки, такие как имя игрока, цвета, звук и язык, чтобы сайт мог помнить их на вашем устройстве.",
  "moreInfo.cookiePolicy.intro1": "Этот сайт использует cookies и похожие технологии хранения, чтобы запускать игру, запоминать настройки и поддерживать рекламу.",
  "moreInfo.cookiePolicy.intro2": "Cookies также могут использоваться для измерений, предотвращения мошенничества и персонализации рекламы в зависимости от вашего согласия и включенных на сайте служб.",
  "moreInfo.cookiePolicy.typesHeading": "Типы cookies и хранилища, которые мы можем использовать",
  "moreInfo.cookiePolicy.typeBullet1": "Необходимое хранилище для работы сайта.",
  "moreInfo.cookiePolicy.typeBullet2": "Хранилище предпочтений для запоминания имени, цветов, языка и настройки звука.",
  "moreInfo.cookiePolicy.typeBullet3": "Рекламные или измерительные cookies, используемые рекламными партнерами, такими как Google, когда реклама включена.",
  "moreInfo.cookiePolicy.manageHeading": "Как управлять cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Вы можете управлять cookies через сообщение о согласии на сайте, когда оно доступно, или через настройки браузера. Отключение некоторых cookies может повлиять на функции сайта или показ рекламы.",
  "moreInfo.privacyPolicy.intro1": "Этот сайт — браузерная игра, управляемая Michał Kierzkowski. Мы стараемся собирать как можно меньше персональной информации.",
  "moreInfo.privacyPolicy.intro2": "Для игры не требуется учетная запись. Игра может сохранять базовые локальные настройки на вашем устройстве и обрабатывать игровые данные, необходимые для онлайн-матчей.",
  "moreInfo.privacyPolicy.infoHeading": "Информация, которую мы можем обрабатывать",
  "moreInfo.privacyPolicy.infoBullet1": "Выбранное имя игрока и косметические настройки.",
  "moreInfo.privacyPolicy.infoBullet2": "Базовые данные сессии, необходимые для многопользовательских функций.",
  "moreInfo.privacyPolicy.infoBullet3": "Данные устройства, браузера или рекламы, собираемые аналитическими или рекламными партнерами, если эти службы включены.",
  "moreInfo.privacyPolicy.useHeading": "Как мы используем информацию",
  "moreInfo.privacyPolicy.useBullet1": "Для работы игры и онлайн-комнат.",
  "moreInfo.privacyPolicy.useBullet2": "Чтобы запоминать настройки на вашем устройстве.",
  "moreInfo.privacyPolicy.useBullet3": "Чтобы улучшать производительность, безопасность и стабильность.",
  "moreInfo.privacyPolicy.useBullet4": "Чтобы показывать рекламу, когда реклама включена.",
  "moreInfo.privacyPolicy.contactHeading": "Контакт",
  "moreInfo.privacyPolicy.contactParagraph1": "По вопросам конфиденциальности пишите: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Сайт: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Используя этот сайт, вы соглашаетесь пользоваться игрой законно и честно.",
  "moreInfo.terms.intro2": "Игра предоставляется как есть и может быть изменена, прервана или удалена в любое время.",
  "moreInfo.terms.rulesHeading": "Правила",
  "moreInfo.terms.ruleBullet1": "Не злоупотребляйте ошибками, читами, автоматизацией или эксплойтами.",
  "moreInfo.terms.ruleBullet2": "Не пытайтесь навредить сервису или другим игрокам.",
  "moreInfo.terms.ruleBullet3": "Не используйте оскорбительные, незаконные или вводящие в заблуждение имена или контент.",
  "moreInfo.terms.limitationHeading": "Ограничение",
  "moreInfo.terms.limitationParagraph": "Мы не несем ответственности за потери, перебои или ущерб, возникшие из-за использования сайта, в максимальной степени, разрешенной законом.",
  "moreInfo.terms.changesHeading": "Изменения",
  "moreInfo.terms.changesParagraph": "Эти условия могут быть обновлены в будущем. Продолжение использования сайта после обновлений означает принятие обновленных условий.",
  "status.offline": "Запуск офлайн-матча...",
  "status.connecting": "Подключение к серверу...",
  "queue.title": "Ожидание комнаты",
  "queue.menu": "Вернуться в главное меню",
  "game.pressToMove": "Нажмите где угодно, чтобы двигаться",
  "game.touchToMove": "Коснитесь где угодно, чтобы двигаться",
  "game.leaderboard": "Таблица лидеров",
  "game.hp": "HP",
  "game.level": "Уровень",
  "game.xp": "XP",
  "game.respawning": "Возрождение...",
  "gameEnd.title": "Конец игры",
  "gameEnd.winTitle": "Вы победили",
  "gameEnd.subtitle": "Матч завершен. Возродитесь, чтобы начать следующий раунд, или вернитесь в меню.",
  "pause.title": "Меню игры",
  "pause.resume": "Продолжить",
  "pause.menu": "Вернуться в главное меню",
  "upgrade.title": "Выберите улучшение",
  "upgrade.generic.title": "Улучшение",
  "upgrade.generic.description": "Улучшите свой билд.",
  "upgrade.newWeaponPrefix": "Новое оружие:",
  "upgrade.stat.maxHp.title": "Макс. HP",
  "upgrade.stat.maxHp.description": "Увеличивает максимальное HP.",
  "upgrade.stat.speed.title": "Скорость передвижения",
  "upgrade.stat.speed.description": "Увеличивает скорость передвижения.",
  "upgrade.stat.generic.title": "Улучшение характеристики",
  "upgrade.stat.generic.description": "Улучшите свои характеристики.",
  "upgrade.weapon.projectileShot.title": "Выстрел снарядом",
  "upgrade.weapon.projectileShot.description": "Добавляет выстрелы снарядами в ваш билд.",
  "upgrade.weapon.orbitingBalls.title": "Орбитальные шары",
  "upgrade.weapon.orbitingBalls.description": "Добавляет орбитальные шары в ваш билд.",
  "upgrade.weapon.damageZone.title": "Зона урона",
  "upgrade.weapon.damageZone.description": "Добавляет зону урона вокруг персонажа.",
  "upgrade.weapon.generic.title": "Оружие",
  "upgrade.weapon.generic.description": "Добавьте это оружие в свой билд.",
  "upgrade.weaponUpgrade.frequency.title": "Частота",
  "upgrade.weaponUpgrade.frequency.description": "Атакуйте чаще.",
  "upgrade.weaponUpgrade.range.title": "Дальность",
  "upgrade.weaponUpgrade.range.description": "Увеличивает дальность оружия.",
  "upgrade.weaponUpgrade.projectileCount.title": "Количество снарядов",
  "upgrade.weaponUpgrade.projectileCount.description": "Создает больше снарядов.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Скорость снарядов",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Делает снаряды быстрее.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Орбитальная скорость",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Заставляет орбитальные шары вращаться быстрее.",
  "upgrade.weaponUpgrade.damage.title": "Урон",
  "upgrade.weaponUpgrade.damage.description": "Наносит больше урона.",
  "upgrade.weaponUpgrade.generic.title": "Улучшение оружия",
  "upgrade.weaponUpgrade.generic.description": "Улучшите это оружие.",
  "defeat.title": "Поражение",
  "defeat.subtitle": "Возродитесь или вернитесь в меню",
  "defeat.respawn": "Возродиться",
  "defeat.menu": "Главное меню",
  "error.generic": "Что-то пошло не так.",
} as const;
